module.exports = __webpack_public_path__ + "static/media/nps_sip_icon.f29a5943.svg";